// Bancos comerciales por país (ISO 3166-1 alpha-2), para el selector de "Banco"
// en la configuración de transferencia manual del operador.
//
// IMPORTANTE: estas nóminas se investigaron contra los reguladores oficiales de
// cada país (BCRA, CMF, SBS, Superfinanciera, Superintendencia de Bancos EC, BCU,
// SUDEBAN) al 2026-06-29, pero CAMBIAN con fusiones, nuevas licencias y revocaciones.
// El campo "Banco" admite además "Otro banco (especificar)" como texto libre, así
// que una nómina ligeramente desactualizada no bloquea al operador. Reverificar
// contra el regulador antes de tratarlas como dato maestro.
//
// Alcance: bancos donde una empresa tendría cuenta para RECIBIR transferencias
// (se excluyeron compañías financieras, cajas, cooperativas, billeteras y banca
// de segundo piso, salvo casos muy usados marcados en la investigación).

export const BANKS_BY_COUNTRY = {
  AR: [
    'BACS Banco de Crédito y Securitización',
    'Banco BBVA Argentina',
    'Banco BICA',
    'Banco CMF',
    'Banco Cetelem Argentina',
    'Banco Coinag',
    'Banco Columbia',
    'Banco Comafi',
    'Banco Credicoop',
    'Banco Dino',
    'Banco Hipotecario',
    'Banco Industrial (BIND)',
    'Banco Julio',
    'Banco Macro',
    'Banco Mariva',
    'Banco Masventas',
    'Banco Meridian',
    'Banco Municipal de Rosario',
    'Banco Patagonia',
    'Banco Piano',
    'Banco Provincia (Banco de la Provincia de Buenos Aires)',
    'Banco Provincia de Tierra del Fuego',
    'Banco Provincia del Neuquén',
    'Banco Rioja',
    'Banco Roela',
    'Banco Saenz',
    'Banco Santander Argentina',
    'Banco Sucrédito Regional',
    'Banco Supervielle',
    'Banco Voii',
    'Banco de Comercio',
    'Banco de Corrientes',
    'Banco de Córdoba (Banco de la Provincia de Córdoba)',
    'Banco de Formosa',
    'Banco de Inversión y Comercio Exterior (BICE)',
    'Banco de Galicia y Buenos Aires (Banco Galicia)',
    'Banco de Servicios Financieros',
    'Banco de Servicios y Transacciones',
    'Banco de Valores',
    'Banco de la Ciudad de Buenos Aires (Banco Ciudad)',
    'Banco de la Nación Argentina (Banco Nación)',
    'Banco de la Pampa',
    'Banco de San Juan',
    'Banco de Santa Cruz',
    'Banco de Santiago del Estero',
    'Banco del Chubut',
    'Banco del Sol',
    'Bibank',
    'Brubank',
    'HSBC Bank Argentina',
    'ICBC (Industrial and Commercial Bank of China Argentina)',
    'Nuevo Banco de Entre Ríos',
    'Nuevo Banco de Santa Fe',
    'Nuevo Banco del Chaco',
    'Open Bank Argentina (Openbank)',
    'Wilobank',
  ],
  CL: [
    'Banco BICE',
    'Banco BTG Pactual Chile',
    'Banco Consorcio',
    'Banco Falabella',
    'Banco Internacional',
    'Banco Itaú Chile',
    'Banco Ripley',
    'Banco Santander',
    'Banco de Chile',
    'Banco de Crédito e Inversiones (BCI)',
    'BancoEstado',
    'HSBC Bank (Chile)',
    'Scotiabank Chile',
    'Tanner Banco Digital',
  ],
  PE: [
    'Agrobanco',
    'Alfin Banco',
    'BBVA Perú',
    'BCI Perú',
    'BanBif',
    'Banco Falabella',
    'Banco GNB',
    'Banco Pichincha',
    'Banco Ripley',
    'Banco Santander Perú',
    'Banco de Crédito del Perú',
    'Banco de la Nación',
    'Bancom',
    'Bank of China (Perú)',
    'COFIDE',
    'Citibank del Perú',
    'Compartamos Banco',
    'ICBC Perú',
    'Interbank',
    'Mibanco',
    'Santander Consumer Perú',
    'Scotiabank Perú',
  ],
  CO: [
    'Ban100',
    'Banco AV Villas',
    'Banco Agrario de Colombia',
    'Banco BTG Pactual Colombia',
    'Banco Caja Social',
    'Banco Contactar',
    'Banco Cooperativo Coopcentral',
    'Banco Davivienda',
    'Banco Falabella',
    'Banco Finandina',
    'Banco GNB Sudameris',
    'Banco Itaú',
    'Banco J.P. Morgan Colombia',
    'Banco Mundo Mujer',
    'Banco Pichincha',
    'Banco Popular',
    'Banco Santander de Negocios Colombia',
    'Banco Serfinanza',
    'Banco Unión',
    'Banco W',
    'Banco de Bogotá',
    'Banco de Occidente',
    'Bancamía',
    'Bancolombia',
    'Bancoomeva',
    'BBVA Colombia',
    'Citibank Colombia',
    'DAVIbank',
    'Lulo Bank',
    'Mibanco',
    // Cuentas digitales no-bancarias (Nu = compañía de financiamiento, Nequi =
    // SEDPE/billetera), no son bancos formales pero se usan mucho para recibir
    // transferencias; incluidas por decisión de producto.
    'Nequi',
    'Nu (Nubank)',
  ],
  EC: [
    'Banco Amazonas',
    'Banco Atlántida',
    'Banco Bolivariano',
    'Banco Capital',
    'Banco Codesarrollo',
    'Banco Comercial de Manabí',
    'Banco CoopNacional',
    'Banco Delbank',
    'Banco Diners Club del Ecuador',
    'Banco General Rumiñahui',
    'Banco Guayaquil',
    'Banco Internacional',
    'Banco Pichincha',
    'Banco ProCredit',
    'Banco Solidario',
    'Banco VisionFund Ecuador',
    'Banco del Austro',
    'Banco del Litoral',
    'Banco del Pacífico',
    'Banco de Loja',
    'Banco de Machala',
    'BanEcuador',
    'Citibank Ecuador',
    'Produbanco',
  ],
  UY: [
    'BBVA Uruguay',
    'Banco Bandes Uruguay',
    'Banco Hipotecario del Uruguay',
    'Banco Itaú Uruguay',
    'Banco Santander Uruguay',
    'Banco de la Nación Argentina',
    'Banco de la República Oriental del Uruguay (BROU)',
    'Banque Heritage (Uruguay)',
    'Citibank Uruguay',
    'HSBC Bank (Uruguay)',
    'Scotiabank Uruguay',
  ],
  VE: [
    '100% Banco',
    'Banco Activo',
    'Banco Agrícola de Venezuela',
    'Banco Bicentenario del Pueblo',
    'Banco Caroní',
    'Banco Exterior',
    'Banco Mercantil',
    'Banco Nacional de Crédito (BNC)',
    'Banco Plaza',
    'Banco Sofitasa',
    'Banco del Tesoro',
    'Banco de Venezuela',
    'Bancamiga',
    'Bancaribe',
    'Bancrecer',
    'Banesco',
    'Bangente',
    'Banplus',
    'BBVA Provincial',
    'BFC Banco Fondo Común',
    'Mi Banco',
    'N58 Banco Digital',
    'R4 Banco',
    'Venezolano de Crédito',
  ],
};

// Lista de bancos para un país (ISO alpha-2). undefined si no hay nómina (cae a
// texto libre en el formulario).
export const banksForCountry = (iso) =>
  iso ? BANKS_BY_COUNTRY[String(iso).toUpperCase()] : undefined;
